import React from 'react';
import UseDetail from '../userDetail';
import DeleteUser from '../userDelete';
import UserEdit from '../userEditOrAdd';
import UserRequest from '../userRequest';
export var getModalContent = function getModalContent(modalType, options) {
  var selectedUser = options.selectedUser,
      translate = options.translate,
      prefix = options.prefix,
      onModalDataChange = options.onModalDataChange,
      ref = options.ref,
      orgId = options.orgId,
      getHttpRequestStatus = options.getHttpRequestStatus;

  switch (modalType) {
    case 'add':
      return /*#__PURE__*/React.createElement(UserEdit, {
        ref: ref,
        getHttpRequestStatus: getHttpRequestStatus,
        orgId: orgId,
        translate: translate,
        onDataChange: onModalDataChange,
        prefix: prefix
      });

    case 'edit':
      return /*#__PURE__*/React.createElement(UserEdit, {
        ref: ref,
        orgId: orgId,
        getHttpRequestStatus: getHttpRequestStatus,
        selectedUser: selectedUser,
        translate: translate,
        onDataChange: onModalDataChange,
        prefix: prefix
      });

    case 'detail':
      if (selectedUser) {
        return /*#__PURE__*/React.createElement(UseDetail, {
          selectedUser: selectedUser,
          translate: translate,
          prefix: prefix
        });
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null);
      }

    case 'delete':
      if (selectedUser) {
        return /*#__PURE__*/React.createElement(DeleteUser, {
          ref: ref,
          selectedUser: selectedUser,
          translate: translate,
          onDataChange: onModalDataChange,
          getHttpRequestStatus: getHttpRequestStatus,
          prefix: prefix,
          orgId: orgId
        });
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null);
      }

    case 'request':
      return /*#__PURE__*/React.createElement(UserRequest, {
        ref: ref,
        getHttpRequestStatus: getHttpRequestStatus,
        onDataChange: onModalDataChange,
        translate: translate,
        prefix: prefix
      });

    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};